// extracted by mini-css-extract-plugin
module.exports = {"menuIconContainer":"TableMenu_menuIconContainer__31BZ5","menuIcon":"TableMenu_menuIcon__2b7fn"};